export default __webpack_public_path__ + "static/media/RecursionImg.5a40ae0f.jpg";